
import axios from "@/axios.js"

export default {
  fetchItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/auto-invoices")
        .then((response) => {
          commit('SET_ITEMS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchItemsByArtisan({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/auto-invoices-by-artisan`)
        .then((response) => {
          commit('SET_ITEMS_ARTISAN', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  getItem(_, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/auto-invoice/${id}`)
        .then((response) => {
          console.log("------------:",response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/auto-invoice", item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/auto-invoice/${item.id}`, item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateStatus({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/auto-invoice/${item.id}/status`, {status: item.status})
        .then((response) => {
          commit('UPDATE_ITEM_STATUS', {id: item.id, status: item.status})
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/auto-invoice/${itemId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },




}
